import React from "react";
import { Grid, Typography, Button, Box } from "@mui/material";
import logo from "../images/logoNoWordsTransparent.png";
import useStyles from "../styles/styles";

const Intro = () => {
  const classes = useStyles();

  return (
    <Box className={classes.heroBox}>
      <Grid container spacing={6} className={classes.gridContainer}>
        <Grid item xs={12} md={7}>
          <Typography variant="h3" fontWeight={700} className={classes.title}>
            MERGING KC
          </Typography>
          <Typography variant="h5" className={classes.subtitle}>
            Kansas City's premier group focused on bridging the gap and creating
            the ultimate collaboration to end homelessness and restore the green
            spaces in the community.
          </Typography>
          <a
            className="nav-link text-white"
            href="https://www.paypal.com/paypalme/mergingkc"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              variant="contained"
              sx={{
                width: "200px",
                fontSize: "16px",
                backgroundColor: "#3c6e71",
              }}
            >
              DONATE
            </Button>
          </a>
        </Grid>
        <Grid item xs={12} md={5}>
          <img src={logo} alt="logo" className={classes.largeImage} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Intro;
